import * as React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: '#3F3F6E', marginTop: '5px' }} />,
    title: 'Grow Faster, Earn More — with 0% to 30% Platform Fees',
    description:
      'We designed our fee model to empower restaurants at every stage. Start risk-free, scale your reach, and maximize your profits — your bottom line will thank you.',
  },
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: '#3F3F6E', marginTop: '5px' }} />,
    title: 'Stay on Top — Earn Priority Without Paying Extra',
    description:
      'When a customer joins through your invitation, your restaurant will always stay at the top of their list — a lasting advantage, with zero cost, just shared success.',
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: '#3F3F6E', marginTop: '5px' }} />,
    title: 'Dedicated Account Manager — Just a Call Away',
    description:
      'You’ll have a dedicated account manager just a call away — here to understand your needs, support your growth, and help you shine while serving your local community.',
  },
];

const SideContentOne = () => {
  return (
    <Stack
      sx={{
        flexDirection: 'column',
        alignSelf: 'center',
        gap: 3,
        maxWidth: 450,
        marginRight: '5px',
      }}
    >
      {/* <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <ThumbUpAltRoundedIcon />
            </Box> */}
      {items.map((item, index) => (
        <Stack key={index} direction='row' sx={{ gap: 2.5 }}>
          {item.icon}
          <div>
            <Typography
              gutterBottom
              sx={{
                fontWeight: 'medium',
                color: '#3F3F6E',
                letterSpacing: '0.5px',
                fontSize: '18px',
              }}
            >
              {item.title}
            </Typography>
            <Typography
              variant='body2'
              sx={{ color: '#4E56C0', letterSpacing: '0.4px', fontSize: '14px' }}
            >
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
};

export default SideContentOne;
